import { cn } from '@/shared/lib/utils'

export type SystemStateVariant = 'not_found' | 'error'

/**
 * Illustration décorative V2 pour les écrans système (404 / 500) - RV-2A.
 * Purement décorative (`aria-hidden`) : le texte de l'état porte déjà le sens (RGAA).
 * Linework via `currentColor` (token sémantique du parent) + accents en vars `--v2-*`.
 */
export function SystemStateIllustration({
  variant,
  className,
}: {
  variant: SystemStateVariant
  className?: string
}) {
  return (
    <svg
      viewBox="0 0 160 120"
      role="presentation"
      aria-hidden
      focusable="false"
      className={cn('mx-auto h-28 w-auto', variant === 'error' ? 'text-destructive' : 'text-primary', className)}
    >
      {variant === 'not_found' ? (
        <>
          <circle cx="80" cy="58" r="46" fill="var(--v2-brand-soft)" />
          <line
            x1="30"
            y1="98"
            x2="130"
            y2="98"
            stroke="var(--v2-ink-4)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="2 8"
          />
          <path
            d="M80 30c-12 0-21 9-21 21 0 15 21 35 21 35s21-20 21-35c0-12-9-21-21-21Z"
            fill="var(--v2-brand-soft)"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinejoin="round"
          />
          <path
            d="M75 46a5 5 0 0 1 9 3c0 3-4 4-4 7"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <circle cx="80" cy="62" r="1.8" fill="currentColor" />
        </>
      ) : (
        <>
          <circle cx="80" cy="58" r="46" fill="var(--v2-accent-soft)" />
          <rect
            x="48"
            y="44"
            width="30"
            height="28"
            rx="6"
            fill="var(--color-card)"
            stroke="currentColor"
            strokeWidth="3"
          />
          <line x1="56" y1="38" x2="56" y2="44" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
          <line x1="70" y1="38" x2="70" y2="44" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
          <path d="M78 58h14" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
          <path
            d="M104 50l-8 8 5 2-6 10 14-12-5-2 6-6Z"
            fill="var(--v2-accent)"
            stroke="var(--v2-accent)"
            strokeWidth="2"
            strokeLinejoin="round"
          />
        </>
      )}
    </svg>
  )
}
